import React from 'react'
import classNames from "classnames";

function InputWrapper({className, children}) {
    return (
        <div className={classNames("input", className)}>
            {children}
        </div>
    )
}

export default InputWrapper
